import React, { useReducer } from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';

import { Auth } from 'aws-amplify';

import BtnPrimary from '../common/BtnPrimary';
import { bsSleep } from '../../utils/manualTimeout';
import InputPassword from '../common/inputs/InputPassword';
import PasswordStrengthMeter from '../common/PasswordStrengthMeter';

const Root = styled.div`
	h2 {
		margin-bottom: 40px;
		font-size: 24px;
		font-weight: bold;
	}

	.form {
		max-width: 700px;
		margin: 0 auto;

		.form__item {
			display: flex;
			align-items: center;
			margin-top: 20px;

			h4 {
				font-size: 16px;
				font-weight: bold;
				line-height: 49px;
				flex: 1 0 33.333333%;
			}

			& > div {
				width: 100%;
			}

			&.has-strength-meter {
				margin: 0;
			}

			&.has-submit {
				margin-top: 40px;
				justify-content: flex-end;

				& > div {
					width: auto;
				}
			}
		}

		.form__error {
			margin: 20px 0 10px 0;
			padding: 20px;
			background-color: ${(props) => props.theme.palette.background.error};
			color: ${(props) => props.theme.palette.text.primary};
			font-size: 16px;
			border-radius: 5px;
		}
	}

	/* .error {
		color: #c60298;
	}

	.firstItemMargin {
		margin-top: 32px;
	}

	.InputContainer {
		.inputFieldLine {
			font-weight: 700;
		}

		.inputHeadline {
			font-size: 24px;
			font-weight: 700;
		}

		hr {
			background-color: #f7cd00;
			height: 2px;
			margin-top: 12px;
		}
	} */
`;

function changePasswordReducer(state, action) {
	switch (action.type) {
		case 'field': {
			return {
				...state,
				[action.fieldName]: action.payload,
			};
		}
		case 'pushingData': {
			return {
				...state,
				isLoading: true,
			};
		}
		case 'success': {
			return {
				oldPassword: '',
				newPassword: '',
				isLoading: false,
			};
		}
		case 'error': {
			return {
				oldPassword: '',
				newPassword: '',
				error: action.error,
				isLoading: false,
			};
		}
		default:
			return state;
	}
}

export default function FormChangePassword() {
	const initialState = {
		oldPassword: '',
		newPassword: '',
		isLoading: false,
		error: '',
	};
	const [state, dispatch] = useReducer(changePasswordReducer, initialState);
	const { oldPassword, newPassword, isLoading, error } = state;

	const onSubmit = async (e) => {
		e.preventDefault();
		dispatch({ type: 'pushingData' });
		await bsSleep(2000);
		Auth.currentAuthenticatedUser()
			.then((user) => Auth.changePassword(user, oldPassword, newPassword))
			.then(dispatch({ type: 'success' }))
			.catch((err) => dispatch({ type: 'error', error: err.message }));
	};

	return (
		<Root>
			<Typography variant="h2">Passwort ändern</Typography>
			<form className="form" onSubmit={onSubmit}>
				{error && (
					<div className="form__error">
						<span>{error}</span>
					</div>
				)}
				<div className="form__item">
					<Typography variant="h4">Altes Passwort</Typography>
					<InputPassword
						passwordValue={oldPassword}
						required
						customInputlabel="Aktuelles Passwort eingeben*"
						dispatch={(e) =>
							dispatch({
								type: 'field',
								fieldName: 'oldPassword',
								payload: e.currentTarget.value,
							})
						}
					/>
				</div>
				<div className="form__item">
					<Typography variant="h4">Neues Passwort</Typography>
					<InputPassword
						passwordValue={newPassword}
						required
						customInputlabel="Neues Passwort vergeben*"
						dispatch={(e) =>
							dispatch({
								type: 'field',
								fieldName: 'newPassword',
								payload: e.currentTarget.value,
							})
						}
					/>
				</div>
				<div className="form__item has-strength-meter">
					<PasswordStrengthMeter StringtoCheck={newPassword} />
				</div>
				<div className="form__item has-submit">
					<BtnPrimary type="submit" variant="contained" disabled={isLoading}>
						{isLoading ? 'Speichern...' : 'Änderungen speichern'}
					</BtnPrimary>
				</div>
			</form>
		</Root>
	);
}
